"use client";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";

import { Ingredients } from "../../Ingredients/Ingredients";
import { Product, RuntimeConfig } from "../../../types/types";
import { useSkinMatchStatus } from "../../../hooks/useSkinMatch/useSkinMatch";
import { useVariant } from "../../../hooks/useVariant/useVariant";
import { useState } from "react";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { getEan } from "@/utils/variant/getEan";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type IngredientsSideDrawerProps = {
  drawerHeading: string;
  product: Product;
  runtimeConfig: RuntimeConfig;
};

export const IngredientsSideDrawerUI = ({
  drawerHeading,
  product,
  runtimeConfig,
}: IngredientsSideDrawerProps) => {
  const { variant } = useVariant(product);
  const ean = getEan(variant);
  const skinMatchLookUpBaseUrl = runtimeConfig?.skinMatchLookUpBaseUrl;
  const skinMatchLookUpData = useSkinMatchStatus(ean, skinMatchLookUpBaseUrl);
  const [open, setOpen] = useState(false);

  if (
    skinMatchLookUpData &&
    skinMatchLookUpData.status == "Done" &&
    skinMatchLookUpData.data.skinMatchStatus
  ) {
    return (
      <>
        <Trigger
          label="Ingredients"
          onClick={withSideDrawerAnalytics("Ingredients", () => setOpen(true))}
        />
        <SEOFriendlyDrawer
          isOpen={open}
          onClose={() => {
            setOpen(false);
          }}
          heading={drawerHeading}
          primaryButtonText="Close"
        >
          <Ingredients product={product} runtimeConfig={runtimeConfig} />
        </SEOFriendlyDrawer>
      </>
    );
  } else {
    return null;
  }
};
